// permission.service.ts
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    private extranetRestrictions: { champs: string[]; fonctions: string[]; menu: string[] } = {
        champs: [],
        fonctions: [],
        menu: [],
    };

    permissionsLoadedSubject = new BehaviorSubject<boolean>(false);
    permissionsLoaded$ = this.permissionsLoadedSubject.asObservable();

    constructor(private _commonService: CommonService) {
        this._commonService.getExtranetRestrictionsStore().subscribe((res) => {
            this.extranetRestrictions = res;
        });
    }

    isPermissionMenu(role: string): boolean {
        return this.extranetRestrictions?.menu?.includes(role);
    }

    isPermissionFonction(role: string): boolean {
        return this.extranetRestrictions?.fonctions?.includes(role);
    }
}
